import { OWNER_SIGN_IN_PATHNAME } from "../consts";

export const OWNER_SIGN_IN_PAGE_ROUTE = {
  TITLE: "Owner sign in",
  KEY: "ownerSignInPage",
  ABSOLUTE_PATH: OWNER_SIGN_IN_PATHNAME,
};
